<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important" v-if="$store.state.showStudentCourses == false">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        الطلبة
        <v-spacer></v-spacer>
        <v-text-field 
          rounded 
          v-model="search" 
          outlined 
          append-icon="mdi-magnify" 
          label="بحث" 
          single-line 
          hide-details
          @input="onSearchInput"
          clearable
        ></v-text-field>
        <div style="width: 20px"></div>
        <AddStudent @reloadTask="loadStudents()" :trainingCenter="trainingCenter" />
      </v-card-title>
      
      <v-data-table 
        :headers="headers" 
        :items="students" 
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="tableLoading"
        :footer-props="{
          'items-per-page-text': 'عدد العناصر في الصفحة:',
          'items-per-page-options': [15, 25, 50, 100],
          'page-text': 'الصفحة {0} من {1}'
        }"
        class="table-content table-warning-color"
        loading-text="جاري تحميل البيانات..."
        no-data-text="لا توجد بيانات"
        @update:options="loadStudents"
      >
        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ getItemIndex(index) }}</h4>
        </template>

        <template v-slot:[`item.studentName`]="{ item }">
          <v-btn text @click="studentSelected(item)">{{ item.studentName }}</v-btn>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <StudentCourse :courses="courses" :studentId="item" style="display: inline-block" />
          <span width="30px"></span>
          <UpdateStudent :student="item" @reloadTask="loadStudents()" style="display: inline-block" v-if="$store.state.userData.roleId == 1" />
          <span width="30px"></span>
          <v-btn icon @click="dialog = false">
            <DeleteStudent :dataToDelete="item" @reloadTask="loadStudents()" style="display: inline-block" v-if="$store.state.userData.roleId == 1" />
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <StudentCourses v-else :student="selectStudent" />
  </div>
</template>

<script>
import AddStudent from "./student/AddStudent.vue";
import UpdateStudent from "./student/UpdateStudent.vue";
import DeleteStudent from "./student/DeleteStudent.vue";
import StudentCourse from "./student/StudentCourse.vue";
import StudentCourses from "./StudentCourses.vue";
export default {
  components: {
    AddStudent,
    DeleteStudent,
    StudentCourse,
    StudentCourses,
    UpdateStudent,
  },
  props: {
    trainingCenter: Number,
  },
  data: () => ({
    overlay: false,
    tableLoading: false,
    search: "",
    searchTimeout: null,
    courses: [],
    selectStudent: {},
    headers: [
      { text: "التسلسل", value: "index", sortable: false },
      { text: "اسم الطالب", value: "studentName" },
      { text: "رقم الهاتف", value: "studentPhone" },
      { text: "المواليد", value: "dobFormat" },
      { text: "الاجراءات", value: "actions", sortable: false },
    ],
    students: [],
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false
    },
  }),
  created() {
    this.initialData();
  },
  watch: {
    options: {
      handler() {
        if (!this.overlay) {
          this.loadStudents();
        }
      },
      deep: true,
    },
  },
  methods: {
    initialData() {
      // Load courses first
      let self = this;
      self.overlay = true;

      self.$http
        .get(`${self.$store.state.apiUrl}/courseTrainingCenter/${self.trainingCenter}`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((courses) => {
          self.courses = courses.data;
          self.overlay = false;
          // Load students after courses are loaded
          self.$nextTick(() => {
            self.loadStudents();
          });
        })
        .catch((error) => {
          self.overlay = false;
          console.log(error);
        });
    },

    loadStudents() {
      if (this.overlay) return; // Don't load during initial overlay

      const { page, itemsPerPage } = this.options;
      this.tableLoading = true;

      const params = {
        page: page,
        limit: itemsPerPage,
        search: this.search.trim()
      };

      this.$http
        .get(`${this.$store.state.apiUrl}/studentTrainingCenter/${this.trainingCenter}/paginated`, {
          headers: { Authorization: `Bearer ${this.$store.state.user}` },
          params: params
        })
        .then((response) => {
          this.students = response.data.data;
          this.totalItems = response.data.pagination.totalItems;
          this.tableLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.tableLoading = false;
          
          // Try to show error message if snackbar is available
          try {
            this.$store.commit('showSnackbar', {
              message: 'حدث خطأ في تحميل البيانات',
              color: 'error'
            });
          } catch (e) {
            // Fallback: simple alert if snackbar doesn't exist
            alert('حدث خطأ في تحميل البيانات');
          }
        });
    },

    onSearchInput() {
      // Debounce search to avoid too many API calls
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.options.page = 1; // Reset to first page when searching
        this.loadStudents();
      }, 500);
    },

    getItemIndex(index) {
      const { page, itemsPerPage } = this.options;
      return (page - 1) * itemsPerPage + index + 1;
    },

    studentSelected(student) {
      let self = this;
      self.$store.state.showStudentCourses = true;
      self.selectStudent = student;
    },
  },
};
</script>

<style lang="scss" scoped></style>
